<app-header></app-header>

<div class="page-content">
    
    <div class="mobile-body-container">
        <!-- IMAGE -->
        <div class="login-image-container">
            <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/c42b79b9-c4ac-4210-5e35-956dc442dc00/public" alt="{{getTranslationFor('alt-1')}}">
        </div>

        <div *ngIf="!expired">
            <h1 class="webapp-title nomargin">{{'AUTH.RESET_PASSWORD.TITLE' | translate}}</h1>
            <!-- <p>Crear usuario</p> -->
            <h3>{{loginObj.username}}</h3>
        </div>

        <div form [formGroup]="signin">
            <div *ngIf="mode == 'sendResetLink' && expired">
                <div *ngIf="expired">
                    <h1 class="webapp-title nomargin">{{'AUTH.FORGOT_PASSWORD.SEND_BUTTON' | translate}}</h1>
                    <p>{{ 'AUTH.RESET_PASSWORD.ERRORS.INVALID_TOKEN' | translate }}</p>
                </div>
        
                <!-- EMAIL TO REQUEST A NEW LINK TO CREATE ACCOUNT -->
                <div *ngIf="!isLoading()">
                    <mat-form-field *ngIf="!isLoading()" class="my-mat-form-field">
                        <mat-label>{{'AUTH.REGISTER.EMAIL_PLACEHOLDER' | translate}}</mat-label>
                        <input class="my-mat-fields" matInput placeholder="{{getTranslationFor('email')}}" type="email" required formControlName="email" required (keyup.enter)="onKeyUp($event)">
                    </mat-form-field>
                </div>
                
                <!-- SEND BUTTON -->
                <button (click)="recoverPass()" mat-button class="button button-fill color-dark button-round" [disabled]="!isEmailFilled()">
                    <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
                    <span *ngIf="!isLoading()">{{'AUTH.FORGOT_PASSWORD.SEND_BUTTON' | translate}}</span>
                </button>
            </div>
    
            <div *ngIf="mode == 'setNewPass' && !expired">
                <mat-form-field *ngIf="!expired" class="my-mat-form-field">
                    <mat-label>{{'AUTH.RESET_PASSWORD.NEW_PASSWORD_PLACEHOLDER' | translate}}</mat-label>
                    <input matInput placeholder="{{getTranslationFor('AUTH.RESET_PASSWORD.NEW_PASSWORD_PLACEHOLDER')}}" class="my-mat-fields" formControlName="password" [type]="hide ? 'password' : 'text'" required (keyup.enter)="onKeyUp($event)">
                    <mat-icon matSuffix (click)="hide = !hide" style="align-items: center;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
          
                  <!-- PASS CONFIRM -->
                  <mat-form-field *ngIf="!expired" class="my-mat-form-field">
                    <mat-label>{{'AUTH.RESET_PASSWORD.CONFIRM_NEW_PASSWORD_PLACEHOLDER' | translate}}</mat-label>
                    <input matInput placeholder="{{getTranslationFor('AUTH.LOGIN.PASSWORD_PLACEHOLDER')}}"  class="my-mat-fields" formControlName="passwordConfirm" [type]="hide ? 'password' : 'text'" required (keyup.enter)="onKeyUp($event)">
                    <mat-icon matSuffix (click)="hide = !hide" style="align-items: center;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
          
                  <!-- PASSWORD MATCH -->
                  <div *ngIf="passwordConfirmInput.touched && passwordConfirmInput.errors?.mismatch">
                    <small>Passwords do not match</small>
                  </div>
                  <!-- PASSWORD CONFIRM IS PRESENT -->
                  <p *ngIf="signin.get('passwordConfirm')?.touched && !signin.get('passwordConfirm').value">
                    Password confirmation is required.
                  </p>
          
                  <!-- VALIDATIONS -->
                  <div class="password-checker">
                    <ul>
                      <li [class.valid]="passwordRequirements.minLength">At least 8 characters</li>
                      <li [class.valid]="passwordRequirements.uppercase">An uppercase letter</li>
                      <li [class.valid]="passwordRequirements.lowercase">A lowercase letter</li>
                      <li [class.valid]="passwordRequirements.number">A number</li>
                      <li [class.valid]="passwordRequirements.specialChar">A special character</li>
                    </ul>
                  </div>
    
                <!-- REGISTER BUTTON -->
                <button (click)="setNewPass()" mat-button class="button button-fill color-dark button-round" [disabled]="!areFieldsFilled()">
                    <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
                    <span *ngIf="!isLoading()">{{'AUTH.RESET_PASSWORD.SAVE_NEW_PASS' | translate}}</span>
                </button>
            </div>
        </div>

    </div>
</div>  